exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".svgIconComponent---qOa8m {\n  display: block;\n  pointer-events: none;\n  width: 12px; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---qOa8m"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/svg-icon/svg-icon.scss
// module id = eag5
// module chunks = 1